import { render, staticRenderFns } from "./BettingPoolLayout.vue?vue&type=template&id=4b251600&scoped=true&"
import script from "./BettingPoolLayout.vue?vue&type=script&lang=js&"
export * from "./BettingPoolLayout.vue?vue&type=script&lang=js&"
import style0 from "./BettingPoolLayout.vue?vue&type=style&index=0&id=4b251600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b251600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VList,VListItem,VListItemGroup,VListItemTitle,VMenu,VSlideXTransition,VSpacer})
